<main class="homepage">
  <div class="main_component">
    <div
      *ngIf="user?.token && !user.IsWorker && errorMessage"
      class="resultMessage errorMessage borderRed h-auto ml-4 mr-4 mb-4"
    >
      <span class="message">
        <i class="errorIcon"></i>
        <span>{{ errorMessage }}</span>
      </span>
    </div>

    <!-- NTS MESSAGE -->
    <section class="nts main-page-content">
      <h1>{{ "general.newTradingSystem" | translate }}</h1>
      <p class="exchange-solution">{{ "general.exchangeSolution" | translate }}</p>
    </section>

    <!-- TRADES -->
    <section class="trades main-page-content">
      <div class="img1">
        <div class="inner">
          <h2>
            {{ "exchangeOffers.tradingForestProducts" | translate }}
          </h2>
          <p>{{ "exchangeOffers.tradingForestProductsD" | translate }}</p>
          <div class="trades__buttons-wrapper">
            <div class="buttons-wrapper">
              <button (click)="goToCatalog(IdDirection.buy, IdSection.forestProducts)">
                <span>{{ "general.demands" | translate }}</span>
                <i class="imgdiv"></i>
              </button>
              <button (click)="goToCatalog(IdDirection.sale, IdSection.forestProducts)">
                <span>{{ "general.offers" | translate }}</span>
                <i class="imgdiv"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="img2">
        <div class="inner">
          <h2>
            {{ "exchangeOffers.tradingMetalProducts" | translate }}
          </h2>
          <p>{{ "exchangeOffers.tradingMetalProductsD" | translate }}</p>
          <div class="trades__buttons-wrapper">
            <div class="buttons-wrapper">
              <button (click)="goToCatalog(IdDirection.buy, IdSection.metalProducts)">
                <span>{{ "general.demands" | translate }}</span>
                <i class="imgdiv"></i>
              </button>
              <button (click)="goToCatalog(IdDirection.sale, IdSection.metalProducts)">
                <span>{{ "general.offers" | translate }}</span>
                <i class="imgdiv"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="img3">
        <div class="inner">
          <h2>
            {{ "exchangeOffers.tradingAgriculturalProducts" | translate }}
          </h2>
          <p>{{ "exchangeOffers.tradingAgriculturalProductsD" | translate }}</p>
          <div class="trades__buttons-wrapper">
            <div class="buttons-wrapper">
              <button (click)="goToCatalog(IdDirection.buy, IdSection.agricultural)">
                <span>{{ "general.demands" | translate }}</span>
                <i class="imgdiv"></i>
              </button>
              <button (click)="goToCatalog(IdDirection.sale, IdSection.agricultural)">
                <span>{{ "general.offers" | translate }}</span>
                <i class="imgdiv"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="img4">
        <div class="inner">
          <h2>
            {{ "exchangeOffers.tradingPromisingGoods" | translate }}
          </h2>
          <p>{{ "exchangeOffers.tradingPromisingGoodsD" | translate }}</p>
          <div class="trades__buttons-wrapper">
            <div class="buttons-wrapper">
              <button (click)="goToCatalog(IdDirection.buy, IdSection.promising)">
                <span>{{ "general.demands" | translate }}</span>
                <i class="imgdiv"></i>
              </button>
              <button (click)="goToCatalog(IdDirection.sale, IdSection.promising)">
                <span>{{ "general.offers" | translate }}</span>
                <i class="imgdiv"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- STEP BY STEP GUIDE PREVIEW -->
    <section class="membership-steps main-page-content">
      <div class="steps">
        <div class="step">
          <div class="number">
            <span>1</span>
          </div>
          <p>{{ "general.membershipStep1" | translate }}</p>
        </div>

        <span>&rarr;</span>

        <div class="step">
          <div class="number">
            <span>2</span>
          </div>
          <p>{{ "general.membershipStep2" | translate }}</p>
        </div>

        <span>&rarr;</span>

        <div class="step">
          <div class="number">
            <span>3</span>
          </div>
          <p>{{ "general.membershipStep3" | translate }}</p>
        </div>

        <span>&rarr;</span>

        <div class="step">
          <div class="number">
            <span>4</span>
          </div>
          <p>{{ "general.membershipStep4" | translate }}</p>
        </div>

        <span>&rarr;</span>

        <div class="step">
          <div class="number">
            <span>5</span>
          </div>
          <p>{{ "general.membershipStep5" | translate }}</p>
        </div>

        <button (click)="loginEcpBy()">
          {{ "general.becomeMember" | translate }}
        </button>
      </div>
    </section>

    <div class="today-news-wrapper main-page-content">
      <!--  Торги сегодня-->
      <div class="auction_body">
        <div class="head" id="head">
          <h2>{{ "general.auctions" | translate }}</h2>
        </div>
        <div class="body-block-wrapper">
          <div class="date-wrapper font-s32">
            <p class="mt-2" *ngIf="locale == 'RU'">
              {{ today | date : "d MMMM yyyy" : "" : "ru-BY" }}
            </p>
            <p class="mt-2" *ngIf="locale == 'EN'">
              {{ today | date : "d MMMM yyyy" : "" : "en-GB" }}
            </p>
          </div>
          <div
            class="flexContent jc-sb flex-end borderFormTabs"
            *ngIf="sections$ | async as sections"
          >
            <dx-tabs
              [dataSource]="sections"
              [selectedIndex]="filterTab"
              itemTemplate="itemTemplate"
              (onItemClick)="onChangeTab($event)"
            >
              <div *dxTemplate="let item of 'itemTemplate'">
                <div>{{ item.name }}</div>
              </div>
            </dx-tabs>
          </div>
          <div class="mt-3">
            <div
              class="title flexContent8 mt-2 p-3 font-s12"
              *ngIf="sessionsForDisplay?.length != 0"
            >
              <span class="w-130px">{{
                  "general.auctionsTime" | translate
                }}</span>
              <span class="w-100">{{ "general.sessionName" | translate }}</span>
            </div>
            <div class="section-items__wrapper">
              <div
                class="items font-s12 flexContent8 p-3"
                *ngFor="let item of sessionsForDisplay"
              >
                <span
                  class="w-130px"
                  [ngClass]="{ disabled: item.isArchived }"
                >{{
                    (item.datetimeBegin - 25569) * 24 * 3600 * 1000 + 1
                      | date : "HH:mm" : "+0000"
                  }}</span
                >
                <div
                  *ngIf="isAcceptableRole()"
                  class="flexContent8 w-100 jc-sb"
                  (click)="goToLink(item)"
                >
                  <a class="link" [ngClass]="{ disabled: item.isArchived }">{{
                      item.sessionName
                    }}</a>
                  <span *ngIf="item.isFromNewSystem" class="tag">{{
                      "general.nts" | translate
                    }}</span>
                </div>
                <div
                  *ngIf="!isAcceptableRole()"
                  class="flexContent8 w-100 jc-sb"
                >
                  <p>{{ item.sessionName }}</p>
                  <span *ngIf="item.isFromNewSystem" class="tag">{{
                      "general.nts" | translate
                    }}</span>
                </div>
              </div>
              <div
                *ngIf="sessionsForDisplay?.length == 0"
                class="mt-1 noauctions"
              >
                <span>{{ "general.noAuctions" | translate }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--  Новости -->
      <div class="news_body">
        <div class="head d-flex jc-sb" id="head">
          <div class="flexContent24 jc-fl-st">
            <h2>{{ "general.news" | translate }}</h2>
            <!-- <i class="imgdiv"></i> -->
            <form [formGroup]="formActive">
              <div class="checkbox d-flex" *ngIf="user.IsWorker">
                <dx-check-box
                  text="{{ 'general.activeNews' | translate }}"
                  iconSize="20px"
                  formControlName="onlyActive"
                  (onValueChanged)="onFilterNews($event)"
                  [disabled]="addNewsBody || editDisable"
                >
                </dx-check-box>
              </div>
            </form>
          </div>

          <button
            *ngIf="user.IsWorker"
            class="btn btn-outline-primary px-3 border-radius5"
            (click)="openAddForm()"
            [ngClass]="{ disabled: !Privileges || addNewsBody || editDisable }">
<!--            <i class="news_plus mr-2"-->
<!--               [ngClass]="{disabled: !Privileges || addNewsBody || editDisable}"></i>-->
            {{ "general.addNews" | translate }}
          </button>
        </div>

        <div class="body-block-wrapper">
          <div *ngIf="news?.length == 0 && !user.IsWorker" class="nonews">
            Актуальных новостей нет<!DOCTYPE html>
            <html lang="en">
            <head>
              <meta charset="UTF-8"/>
              <meta
                name="viewport"
                content="width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0"
              />
              <meta http-equiv="X-UA-Compatible" content="ie=edge"/>
              <title>Document</title>
            </head>
            <body></body>
            </html>
          </div>

          <!-- добавление новости -->
          <div class="addNews" *ngIf="addNewsBody">
            <form [formGroup]="form">
              <div class="mb-2">
                <label class="label">{{
                    "general.newsTitle" | translate
                  }}</label>
                <dx-text-box
                  [showClearButton]="true"
                  height="40px"
                  width="900px"
                  formControlName="titleNews"
                >
                </dx-text-box>
              </div>
              <dx-html-editor
                height="300px"
                width="900px"
                [value]="newsContent"
                (onValueChanged)="handleEditorChange($event)"
                formControlName="newsContent">
                <dxo-toolbar [multiline]="true">
                  <dxi-item
                    name="size"
                    [acceptedValues]="acceptedPointSizeValues"
                    [options]="{ inputAttr: { 'aria-label': 'Font size' } }">
                  </dxi-item>

                  <dxi-item
                    name="font"
                    [acceptedValues]="acceptedFontValues"
                    [options]="{ inputAttr: { 'aria-label': 'Font family' } }">
                  </dxi-item>

                  <dxi-item name="bold"></dxi-item>
                  <dxi-item name="italic"></dxi-item>
                  <dxi-item name="underline"></dxi-item>
                  <dxi-item name="alignLeft"></dxi-item>
                  <dxi-item name="alignCenter"></dxi-item>
                  <dxi-item name="alignRight"></dxi-item>
                  <dxi-item name="alignJustify"></dxi-item>
                  <dxi-item name="link"></dxi-item>
                  <dxi-item name="image"></dxi-item>
                  <dxi-item name="orderedList"></dxi-item>
                  <dxi-item name="bulletList"></dxi-item>
                </dxo-toolbar>
              </dx-html-editor>

              <div class="mb-2">
                <label class="label">{{
                    "general.datePublish" | translate
                  }}</label>

                <dx-date-box
                  type="date"
                  width="320px"
                  height="40px"
                  [useMaskBehavior]="true"
                  [min]="currentTimeDate"
                  displayFormat="dd.MM.yyyy"
                  formControlName="datePublish"
                  placeholder="Выберите дату"
                >
                </dx-date-box>
              </div>
            </form>

            <div class="buttons flexContent24 buttonsClass mt-3 mb-3">
              <button
                class="btn btn-primary submit w-50"
                (click)="addNews('add')"
                [disabled]="!form.valid"
              >
                {{ "btns.save" | translate }}
              </button>
              <button
                class="btn btn-outline-primary w-50"
                (click)="closeAddForm()"
              >
                {{ "btns.cancel" | translate }}
              </button>
            </div>

            <hr/>
          </div>

          <!-- редактирование новости -->
          <div class="addNews" *ngIf="isEdit">
            <form [formGroup]="formEdit">
              <div class="mb-2">
                <label class="label">{{"general.newsTitle" | translate}}</label>

                <dx-text-box
                  [showClearButton]="true"
                  width="900px"
                  height="40px"
                  formControlName="titleNews">
                </dx-text-box>
              </div>

              <dx-html-editor
                height="300px"
                width="900px"
                [value]="newsContent"
                valueType="html"
                (onValueChanged)="handleEditorChange($event)"
                formControlName="newsContent">
                <dxo-toolbar [multiline]="true">
                  <dxi-item
                    name="size"
                    [acceptedValues]="acceptedPointSizeValues"
                    [options]="{inputAttr: { 'aria-label': 'Font size' }}">
                  </dxi-item>

                  <dxi-item
                    name="font"
                    [acceptedValues]="acceptedFontValues"
                    [options]="{inputAttr: { 'aria-label': 'Font family' }}">
                  </dxi-item>

                  <dxi-item name="bold"></dxi-item>
                  <dxi-item name="italic"></dxi-item>
                  <dxi-item name="underline"></dxi-item>
                  <dxi-item name="alignLeft"></dxi-item>
                  <dxi-item name="alignCenter"></dxi-item>
                  <dxi-item name="alignRight"></dxi-item>
                  <dxi-item name="alignJustify"></dxi-item>
                  <dxi-item name="link"></dxi-item>
                  <dxi-item name="image"></dxi-item>
                  <dxi-item name="orderedList"></dxi-item>
                  <dxi-item name="bulletList"></dxi-item>
                </dxo-toolbar>
              </dx-html-editor>

              <div class="mb-2">
                <label class="label">{{
                    "general.datePublish" | translate
                  }}</label>

                <dx-date-box
                  type="date"
                  width="320px"
                  height="40px"
                  [useMaskBehavior]="true"
                  [min]="currentTimeDate"
                  displayFormat="dd.MM.yyyy"
                  formControlName="datePublish"
                  placeholder="Выберите дату"
                >
                </dx-date-box>
              </div>
            </form>

            <div class="buttons flexContent24 buttonsClass mt-3 mb-3">
              <button
                class="btn btn-primary submit w-50"
                (click)="addNews('edit', editingNewsId)"
                [disabled]="!formEdit.valid"
              >
                {{ "btns.save" | translate }}
              </button>
              <button
                class="btn btn-outline-primary w-50"
                (click)="closeEditNews(editingNewsId)"
              >
                {{ "btns.cancelEdit" | translate }}
              </button>
            </div>
          </div>


          <div class="news-body-wrapper" *ngIf="!addNewsBody && !isEdit">
            <div class="line"></div>
            <div #newsWrapper>
              <div *ngFor="let item of news">
                <div class="news_item flexContentColumn16">
                  <div *ngIf="!item?.isEdit">
                    <div class="d-flex jc-sb mb-3">
                      <div class="flexContent8">
                        <span class="time">{{
                            (item.datePublish - 25569) * 24 * 3600 * 1000 + 1
                              | date : "EEEEEE. d LLLL yyyy" : "" : "ru-BY"
                          }}</span>
                        <i
                          *ngIf="user.IsWorker && item.isActive"
                          class="activeNews"
                          id="news_{{ item?.idNews }}"
                        ></i>
                        <i
                          *ngIf="user.IsWorker && !item.isActive"
                          class="unactiveNews"
                          id="news_{{ item?.idNews }}"
                        ></i>
                        <dx-tooltip
                          target="#news_{{ item?.idNews }}"
                          showEvent="dxhoverstart"
                          hideEvent="dxhoverend"
                        >
                          {{
                            item.isActive
                              ? ("general.activeNewsTooltip" | translate)
                              : ("general.unActiveNewsTooltip" | translate)
                          }}
                        </dx-tooltip>
                      </div>

                      <div class="menu" *ngIf="user.IsWorker">
                        <i class="dots"></i>
                        <ul class="flexContentColumn4 submenu">
                          <li
                            class="blackColor"
                            [ngClass]="{
                              disabled:
                                !Privileges || addNewsBody || editDisable
                            }"
                            (click)="changeNewsActivity(item?.idNews)"
                          >
                            <i class="arrows"></i
                            ><span>{{
                              "general.changeActivity" | translate
                            }}</span>
                          </li>
                          <li
                            class="blackColor"
                            [ngClass]="{
                              disabled:
                                !Privileges || addNewsBody || editDisable
                            }"
                            (click)="openEditNews2(item?.idNews)"
                          >
                            <i class="pen"></i
                            ><span>{{ "btns.edit" | translate }}</span>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <span class="news_title mb-2">{{ item.newsTitle }}</span>

                    <!-- <div class="font-s12" [innerHTML]="item.newsBody"></div> -->

                    <div [innerHTML]="getSafeHtml(item.newsBody)"></div>

                    <div
                      *ngIf="user.IsWorker"
                      class="resultMessage successMessage borderGreen"
                    >
                      <span class="title font-s12">{{
                          "general.additionalInfo" | translate
                        }}</span>
                      <span class="addInfo font-s12"
                      >{{ "general.create" | translate }}:
                        {{ item.creatorFio }}
                        <span class="">{{
                            (item.dateCreate - 25569) * 24 * 3600 * 1000 + 1
                              | date : "dd.MM.yy" : "+0000"
                          }}</span></span
                      >
                      <span *ngIf="item.dateUpdate" class="addInfo font-s12"
                      >{{ "general.update" | translate }} :
                        {{ item.updaterFio }}
                        <span class="">{{
                            (item.dateUpdate - 25569) * 24 * 3600 * 1000 + 1
                              | date : "dd.MM.yy" : "+0000"
                          }}</span></span
                      >
                      <span *ngIf="item.dateDelete" class="addInfo font-s12"
                      >{{ "general.delete" | translate }} :
                        {{ item.deleterFio }}
                        <span class="">
                          {{
                            (item.dateDelete - 25569) * 24 * 3600 * 1000 + 1
                              | date : "dd.MM.yy" : "+0000"
                          }}</span
                        ></span
                      >
                    </div>
                  </div>

                  <!-- редактирование новости -->
<!--                  <div class="addNews" *ngIf="item?.isEdit">-->
<!--                    <form [formGroup]="form">-->
<!--                      <div class="mb-2">-->
<!--                        <label class="label">{{-->
<!--                            "general.newsTitle" | translate-->
<!--                          }}</label>-->

<!--                        <dx-text-box-->
<!--                          [showClearButton]="true"-->
<!--                          width="900px"-->
<!--                          height="40px"-->
<!--                          formControlName="titleNews"-->
<!--                        >-->
<!--                        </dx-text-box>-->
<!--                      </div>-->

<!--                      <dx-html-editor-->
<!--                        height="300px"-->
<!--                        width="900px"-->
<!--                        [value]="newsContent"-->
<!--                        (onValueChanged)="handleEditorChange($event)"-->
<!--                        formControlName="newsContent"-->
<!--                      >-->
<!--                        <dxo-toolbar [multiline]="true">-->
<!--                          <dxi-item-->
<!--                            name="size"-->
<!--                            [acceptedValues]="acceptedPointSizeValues"-->
<!--                            [options]="{-->
<!--                              inputAttr: { 'aria-label': 'Font size' }-->
<!--                            }"-->
<!--                          ></dxi-item>-->

<!--                          <dxi-item-->
<!--                            name="font"-->
<!--                            [acceptedValues]="acceptedFontValues"-->
<!--                            [options]="{-->
<!--                              inputAttr: { 'aria-label': 'Font family' }-->
<!--                            }"-->
<!--                          ></dxi-item>-->

<!--                          <dxi-item name="bold"></dxi-item>-->
<!--                          <dxi-item name="italic"></dxi-item>-->
<!--                          <dxi-item name="underline"></dxi-item>-->
<!--                          <dxi-item name="alignLeft"></dxi-item>-->
<!--                          <dxi-item name="alignCenter"></dxi-item>-->
<!--                          <dxi-item name="alignRight"></dxi-item>-->
<!--                          <dxi-item name="alignJustify"></dxi-item>-->
<!--                          <dxi-item name="link"></dxi-item>-->
<!--                          <dxi-item name="image"></dxi-item>-->
<!--                          <dxi-item name="orderedList"></dxi-item>-->
<!--                          <dxi-item name="bulletList"></dxi-item>-->
<!--                        </dxo-toolbar>-->
<!--                      </dx-html-editor>-->

<!--                      <div class="mb-2">-->
<!--                        <label class="label">{{-->
<!--                            "general.datePublish" | translate-->
<!--                          }}</label>-->

<!--                        <dx-date-box-->
<!--                          type="date"-->
<!--                          width="320px"-->
<!--                          height="40px"-->
<!--                          [useMaskBehavior]="true"-->
<!--                          [min]="currentTimeDate"-->
<!--                          displayFormat="dd.MM.yyyy"-->
<!--                          formControlName="datePublish"-->
<!--                          placeholder="Выберите дату"-->
<!--                        >-->
<!--                        </dx-date-box>-->
<!--                      </div>-->
<!--                    </form>-->

<!--                    <div class="buttons flexContent24 buttonsClass mt-3 mb-3">-->
<!--                      <button-->
<!--                        class="btn btn-primary submit w-50"-->
<!--                        (click)="addNews('edit', item?.idNews)"-->
<!--                        [disabled]="!form.valid"-->
<!--                      >-->
<!--                        {{ "btns.save" | translate }}-->
<!--                      </button>-->
<!--                      <button-->
<!--                        class="btn btn-outline-primary w-50"-->
<!--                        (click)="closeEditNews(item?.idNews)"-->
<!--                      >-->
<!--                        {{ "btns.cancelEdit" | translate }}-->
<!--                      </button>-->
<!--                    </div>-->
<!--                  </div>-->
                </div>
                <hr class="my-4"/>
              </div>
            </div>
          </div>

          <div class="news-pagination-wrapper mt-2 w-100" *ngIf="!addNewsBody && !isEdit">
            <pagination
              [pageSizeVisible]="false"
              [pageSize]="pageSize"
              [totalPages]="totalPages"
              [currentPage]="currentPage"
              (changePage)="onChangePage($event)"
            >
            </pagination>
          </div>
        </div>
      </div>
    </div>

    <div class="catalogue-wrapper main-page-content">
      <div class="catalogue-wrapper__block img1">
        <p class="block__header font-s48 font-w500 w-130px mt-1">
          {{ "general.userManual" | translate }}
        </p>
        <a href="./instructions" target="_blank">
          <span>{{ "general.examineTradeRegulations" | translate }}</span>
          <i class="imgdiv"></i>
        </a>
      </div>

      <div class="catalogue-wrapper__block img2">
        <p class="block__header font-s48 font-w500 w-130px mt-1">
          {{ "general.tradeRegulations" | translate }}
        </p>
        <a
          href="https://www.butb.by/pravovye-akty/normativnye-dokumenty-birzhi/"
          target="_blank"
        >
          <span>{{ "general.examineTradeRegulations" | translate }}</span>
          <i class="imgdiv"></i>
        </a>
      </div>

      <div class="catalogue-wrapper__block img3">
        <p class="block__header font-s48 font-w500 mt-1 mb-0">
          {{ "general.tradingSystemStructure" | translate }}
        </p>
        <a href="./structure" target="_blank">
          <span>{{ "general.examineStructure" | translate }}</span>
          <i class="imgdiv"></i>
        </a>
      </div>
    </div>

   <!--  <div class="guides-wrapper main-page-content" id="guides">
      <div class="guides-wrapper__block">
        <div class="header-wrapper-with-buttons">
          <h2>{{ "general.userManual" | translate }}</h2>
          <div class="headDocs jc-end flexContent16">
            <div class="btns" *ngIf="this.user.IsWorker">
              <div
                class="btn w-180px trader"
                [ngClass]="{ activeBtn: isTraderActive }"
                (click)="viewDocs('trader')">
                {{ "structure.forTrader" | translate }}
              </div>
              <div
                class="btn w-180px worker"
                [ngClass]="{ activeBtn: isWorkerActive }"
                (click)="viewDocs('worker')">
                {{ "structure.forWorker" | translate }}
              </div>
            </div>
          </div>
        </div>
        <div class="guides-flex">
        <div class="guides-items-role">
          <ul class="items-role__menu" *ngFor="let item of guide">
            <li
              (click)="togglegGuide(item.id)"
              [ngClass]="{ 'item-selected': item.selected }"
            >
              {{ item.title }}
            </li>
          </ul>
        </div>

        <div class="guides-content flexContentColumn16">
          <div class="guides-items-wrapper">
            <ng-container *ngFor="let item of guideElementsForDisplay">
              <div class="guide-items">
                <div *ngIf="item.type == 'pdf'" class="guide-item__icon"></div>
                <div
                  *ngIf="item.type == 'video'"
                  class="guide-video__icon"
                ></div>
                <div *ngIf="item.type == 'link'" class="guide-link__icon"></div>
                <div class="guide-item__content">
                  <div class="guide-item__text font-s14 font-w600">
                    <a target="_blank" href="{{ item.path }}">{{
                        item.name
                      }}</a>
                  </div>
                  <div class="guide-item__size">{{ item.size }}</div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      </div>
    </div> -->

    <div class="FAQ main-page-content">
      <div class="FAQ-wrapper">
        <div class="FAQ-header">
          <h2 class="d-flex jc-c mb-2">
            {{ "general.FAQ" | translate }}
          </h2>
          <div class="headDocs jc-end flexContent16" style="align-items: center">
            <input
              class="searchIcon"
              type="text"
              [(ngModel)]="searchTerm"
              (input)="onSearchChange()"
              [placeholder]="'general.search' | translate"/>
            <div class="btns" *ngIf="this.user.IsWorker">
              <div
                class="btn w-180px trader"
                [ngClass]="{ activeBtn: isTraderActive }"
                (click)="viewDocs('trader')">
                {{ "structure.forTrader" | translate }}
              </div>
              <div
                class="btn w-180px worker"
                [ngClass]="{ activeBtn: isWorkerActive }"
                (click)="viewDocs('worker')">
                {{ "structure.forWorker" | translate }}
              </div>
            </div>
          </div>
        </div>

        <div class="FAQ-items">
          <div class="FAQ-items-role">
            <div *ngFor="let topic of topics" class="main-item">
              <div
                class="menu-title flexContent16 jc-sb"
                (click)="toggleTopic(topic)"
              >
                <span>{{ topic.title }}</span>
                <a
                  class="arrow-down"
                  [ngClass]="{ 'tr-rt180': topic.expanded }"
                ></a>
              </div>
              <div *ngIf="topic.expanded">
                <div
                  class="item"
                  *ngFor="let item of topic.items; let index = index"
                  [ngClass]="{ selected: item.selected }"
                  (click)="selectTopic(item.id)"
                >
                  {{ item.heading }}
                </div>
              </div>
            </div>
          </div>

          <div class="FAQ-content flexContentColumn16">
            <div class="FAQ-wrap flexContentColumn16">
              <div
                class="item"
                *ngFor="let faq of faqsForDisplay; let i = index"
              >
                <div class="head d-flex jc-sb center" (click)="toggle(i)">
                  <span class="faq">{{ faq.question }}</span>
                  <i class="plus" [ngClass]="{ minus: faq.open }"></i>
                </div>

                <div class="answer" *ngIf="faq.open">
                  <div [innerHTML]="faq.answer" class="pre-class"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>

<dx-load-panel
  shadingColor="rgba(0,0,0,0.4)"
  [(visible)]="loadingVisible"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [hideOnOutsideClick]="false"
>
</dx-load-panel>
